import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const getSubscriptionReports = ( params: any) => {
    return axios({
      method: "GET",
      url: "/plans/reports",
      params:{
        ...params,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

export const addSubscriptionReports = (data: any, params: any) => {
  return axios({
    method: "POST",
    url: `/plans/reports/export?format=${params?.format}&section=${params?.section}&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};